function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6.5L7.85867 9.43973C7.87722 9.45884 7.89925 9.47399 7.9235 9.48434C7.94775 9.49468 7.97375 9.5 8 9.5C8.02625 9.5 8.05225 9.49468 8.0765 9.48434C8.10075 9.47399 8.12278 9.45884 8.14133 9.43973L11 6.5",
  stroke: "#333333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6.5L7.85867 9.43973C7.87722 9.45884 7.89925 9.47399 7.9235 9.48434C7.94775 9.49468 7.97375 9.5 8 9.5C8.02625 9.5 8.05225 9.49468 8.0765 9.48434C8.10075 9.47399 8.12278 9.45884 8.14133 9.43973L11 6.5",
  stroke: "black",
  strokeOpacity: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6.5L7.85867 9.43973C7.87722 9.45884 7.89925 9.47399 7.9235 9.48434C7.94775 9.49468 7.97375 9.5 8 9.5C8.02625 9.5 8.05225 9.49468 8.0765 9.48434C8.10075 9.47399 8.12278 9.45884 8.14133 9.43973L11 6.5",
  stroke: "black",
  strokeOpacity: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6.5L7.85867 9.43973C7.87722 9.45884 7.89925 9.47399 7.9235 9.48434C7.94775 9.49468 7.97375 9.5 8 9.5C8.02625 9.5 8.05225 9.49468 8.0765 9.48434C8.10075 9.47399 8.12278 9.45884 8.14133 9.43973L11 6.5",
  stroke: "black",
  strokeOpacity: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6.5L7.85867 9.43973C7.87722 9.45884 7.89925 9.47399 7.9235 9.48434C7.94775 9.49468 7.97375 9.5 8 9.5C8.02625 9.5 8.05225 9.49468 8.0765 9.48434C8.10075 9.47399 8.12278 9.45884 8.14133 9.43973L11 6.5",
  stroke: "black",
  strokeOpacity: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgChevron16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron16);
export default __webpack_public_path__ + "static/media/chevron16.fdf5c1d8.svg";
export { ForwardRef as ReactComponent };